import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "dark",

    primary: {
      main: "#22c55e", // green highlight
      contrastText: "#0f172a",
    },

    secondary: {
      main: "#16a34a",
    },

    background: {
      default: "#0f172a",
      paper: "#020617",
    },

    text: {
      primary: "#e5e7eb",
      secondary: "#9ca3af",
    },
  },

  components: {
    /* ================= APP BAR ================= */
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#020617",
        },
      },
    },

    /* ================= BUTTON ================= */
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: "12px 20px",

          /* FOCUS OUTLINE */
          "&:focus-visible": {
            outline: "3px solid #22c55e",
            outlineOffset: "2px",
          },
        },
      },
    },

    /* ================= TEXT FIELD ================= */
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          backgroundColor: "#020617",

          /* FOCUS OUTLINE */
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#22c55e",
            borderWidth: 2,
          },

          /* HOVER */
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#22c55e",
          },
        },
      },
    },

    /* ================= SELECT ================= */
    MuiSelect: {
      styleOverrides: {
        select: {
          minHeight: 48,

          "&:focus": {
            backgroundColor: "transparent",
          },
        },
      },
    },

    /* ================= MENU ITEM ================= */
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "rgba(34,197,94,0.2)",
          },

          "&.Mui-selected:hover": {
            backgroundColor: "rgba(34,197,94,0.3)",
          },

          "&.Mui-focusVisible": {
            outline: "2px solid #22c55e",
          },
        },
      },
    },

    /* ================= PAPER ================= */
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          borderRadius: 12,
        },
      },
    },
  },
});

export default theme;